const GlobalLoading = ({ show, message = 'CARGANDO' }) => {
  if (!show) return null;

  return (
    <div className="global-loading-overlay">
      <div className="global-loading-box text-primary">
        <div className='spinner-border text-primary'></div>
        <div className='fs-6 fw-bold'>{message}...</div>
      </div>
    </div>
  );
};

export default GlobalLoading;
